import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzInputModule } from 'ng-zorro-antd/input';
import { Router } from '@angular/router';

interface InputSearchProps { showSearch: boolean }
@Component({
  selector: 'franbase-search-main',
  standalone: true,
  imports: [
    CommonModule,
    SvgIconComponent,
    NzAffixModule,
    NzInputModule
  ],
  templateUrl: './search-main.component.html',
  styleUrls: ['./search-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchMainComponent {

  router = inject(Router);

  @Input() inputClass?: string;
  @Input() case: {
    key: 'in-header' | 'search-result' | 'in-banner',
    props?: InputSearchProps,
  } = { key: 'in-banner' };
  @Output() updateShowSearch = new EventEmitter<boolean>();
  handleUpdateShowSearch(action: 'focus' | 'click') {
    this.updateShowSearch?.emit(action === 'focus' ? true : !this.case.props?.showSearch);
  }

  onSearch(event: any) {
    this.router.navigate(['search-result'], { queryParams: {keyword: event.target.value} });
  }
}
